import { FC } from 'react';
import { ModalContainer, ModalHeader } from '@/utils/modal';
import { RouteService } from '@/support/RouteService';
import { AddSamplePlanProvider } from '@/components/Samples/AddSamplePlanProvider';
import { AddSamplePlansForm } from '@/components/Samples/AddSamplePlansForm';
import {
  GroupTarget,
  PlannedAnimalTarget,
  RegisteredAnimalTarget,
  SampleDefinitionFormData,
} from '@/model/SamplePlan.model';

type StudyCreateSamplePlanFormModalProps = {
  sample_definitions: Array<SampleDefinitionFormData>;
  groups: Array<GroupTarget>;
  planned_animals: Array<PlannedAnimalTarget>;
  registered_animals: Array<RegisteredAnimalTarget>;
  onSubmit: (formData: Array<SampleDefinitionFormData>) => Promise<void>;
  closeModal: () => void;
};
export const StudyCreateSamplePlanFormModal: FC<StudyCreateSamplePlanFormModalProps> = ({
  sample_definitions,
  groups,
  planned_animals,
  registered_animals,
  onSubmit,
  closeModal,
}) => {
  return (
    <ModalContainer size="wide">
      <ModalHeader
        title="Sampling plan"
        subText={
          <>
            Specify how samples should be collected from groups.{' '}
            <a className="link" href={RouteService.help('sample_planning')} target="_blank" rel="noopener noreferrer">
              Read more
            </a>
            .
          </>
        }
        closeModal={closeModal}
        className="pa3 bb b--moon-gray bg-white"
      />
      <div className="mh4 mt3">
        <AddSamplePlanProvider
          groups={groups}
          registered_animals={registered_animals}
          planned_animals={planned_animals}
          sample_definitions={sample_definitions}
          onSubmit={onSubmit}
        >
          <AddSamplePlansForm />
        </AddSamplePlanProvider>
      </div>
    </ModalContainer>
  );
};
